function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.891 1.034v5.882l-1.19-1.21a1.02 1.02 0 00-1.452-.009 1.04 1.04 0 00-.006 1.463l2.937 2.99a1.027 1.027 0 001.475 0l2.937-2.99a1.039 1.039 0 00-.007-1.463 1.02 1.02 0 00-1.452.008L8.944 6.917V1.035A1.03 1.03 0 007.917-.001a1.03 1.03 0 00-1.026 1.035zM1 11.03v2.019c0 1.553 1.25 2.813 2.79 2.813h8.254c1.541 0 2.791-1.26 2.791-2.813v-2.02c0-.57-.46-1.032-1.026-1.032a1.03 1.03 0 00-1.026 1.033v2.019a.742.742 0 01-.739.745H3.79a.743.743 0 01-.738-.745v-2.02a1.03 1.03 0 00-1.026-1.032A1.03 1.03 0 001 11.03z",
  fill: "#676D75"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgComponent;